if (!customElements.get('bf-countdown')) {
  customElements.define(
    'bf-countdown',
    class extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end);
        if (Number.isNaN(this.end)) return;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
        if (!left) {
          this.hidden = true;
          clearInterval(this.timer);
          return;
        }
        const values = {
          d: Math.floor(left / 86400),
          h: Math.floor(left / 3600) % 24,
          m: Math.floor(left / 60) % 60,
          s: left % 60,
        };
        this.querySelectorAll('[data-unit]').forEach((el) => {
          el.textContent = String(values[el.dataset.unit]).padStart(2, '0');
        });
      }
    }
  );
}

// Shows the bar while no signup form is on screen, but not once the visitor has scrolled past the last one.
if (!customElements.get('bf-sticky-cta')) {
  customElements.define(
    'bf-sticky-cta',
    class extends HTMLElement {
      connectedCallback() {
        const forms = [...document.querySelectorAll('[data-bf-form]')];
        if (!forms.length) return;
        this.update = () => {
          const rects = forms.map((form) => form.getBoundingClientRect());
          const onScreen = rects.some((rect) => rect.bottom > 0 && rect.top < window.innerHeight);
          const pastLastForm = rects[rects.length - 1].bottom < 0;
          this.classList.toggle('is-visible', !onScreen && !pastLastForm);
        };
        window.addEventListener('scroll', this.update, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.update);
      }
    }
  );
}
